import { FC, useRef } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip, usePagingStickyEmulationReports } from "@ryde/controls";
import { useReportsContext } from "@ryde/redux";

import { getReportCategoryIcon } from "./report-icons";
import { ReportTableHeadStyled } from "./reports.styled";

export const ReportTableHeadDiagrams: FC = () => {
  const { t } = useTranslation();
  const { reportTitle, reportDescription, ownerCategory } = useReportsContext();
  const mobileHeaderReportsRef = useRef<HTMLDivElement>(null);
  usePagingStickyEmulationReports({ pagingRef: mobileHeaderReportsRef });
  return (
    <ReportTableHeadStyled ref={mobileHeaderReportsRef}>
      <div className="report_info_wrapper">
        <h2 className="report_title">
          {reportTitle}
          {ownerCategory && (
            <FramerTooltip content={t(`selectListLabel.${ownerCategory}`)}>
              <>{getReportCategoryIcon(ownerCategory)}</>
            </FramerTooltip>
          )}
        </h2>
        {reportDescription && (
          <p className="report_description"> {reportDescription}</p>
        )}
      </div>
      {/* left for future development when diagrams are ready
      <div className="report_buttons">
        <ReportTableHeadDownload />
        <ReportTableHeadSettings />
      </div> */}
    </ReportTableHeadStyled>
  );
};
